module.exports = __webpack_public_path__ + "static/media/background-dm-valjevo.f56bd83f.png";